<template>
  <v-container fluid id="member">
    <div class="van-hairline--bottom van-nav-bar font_weight_bold" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
      <div class="van-ellipsis van-nav-bar__title">{{ $t("member.title") }}</div>
    </div>

    <div class="content2" v-if="!loggedIn">
      <img src="../assets/img/icon_logo_2.png" class="logo_banner" />

      <div class="padding_20">
        <v-row>
          <v-col>
            <h3 class="text-center">{{ $t("login.signInMsg") }}</h3>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col>
            <!-- <GoogleLogin class="btn_login gsibtn" :callback="handleCredentialResponse" /> -->
            <div ref="googleLoginBtn" class="btn_login gsibtn" />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col>
            <v-btn class="btn_login" outlined rounded @click="toLoginGoogle">{{ $t("login.signInByGoogle") }}</v-btn>
          </v-col>
        </v-row> -->
        <v-row justify="center">
          <v-col sm="8" md="6" lg="5" xl="4">
            <v-btn class="btn_login" outlined rounded :to="{ name: 'login' }">{{ $t("login.signInByEmail") }}</v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col sm="8" md="6" lg="5" xl="4">
            <v-btn class="btn_login" outlined rounded :to="{ name: 'register' }">{{ $t("login.register") }}</v-btn>
          </v-col>
        </v-row>
      </div>
    </div>

    <div class="content2" v-if="loggedIn && member">
      <div v-if="!modifying">
        <div class="pa-3">
          <van-field v-model="member.Name" readonly label="Name" placeholder="Member Name" />
          <van-field v-model="member.eMailAddress" readonly label="Email" placeholder="email address" />
          <van-field v-model="member.Phone" readonly label="Phone" placeholder="Phone Number" />

          <van-button plain round type="default" class="btn_edit" @click="toEdit">{{ $t("member.edit") }}</van-button>

          <van-button v-show="this.admin" round type="warning" class="btn_admin" @click="toAdmin">Admin Page</van-button>

          <van-row type="flex" style="margin-top: 5vh;">
            <van-col span="12" class="address-header">Addresses</van-col>
            <van-col span="12" style="text-align:right;">
              <van-button round class="address-add-button" @click="toAddMemberAddress(false)">Add</van-button>
            </van-col>
          </van-row>

          <van-grid :border="false" gutter="10">
            <van-grid-item class="address-item" v-for="(address, index) in addresses" :key="index">
              <div class="address">
                <!-- <div v-if="address.AddrName != ''">
                  <b>{{ address.AddrName }}</b>
                  <br />
                </div> -->
                <div class="float-right" v-if="address.AddrDescription != ''">
                  <b>{{ address.AddrDescription }}</b>
                </div>
                <div v-if="address.AddrAttn != ''">{{ address.AddrAttn }}</div>

                <div>{{ address.AddrLine1 }}</div>
                <div>{{ address.AddrCity }}, {{ address.AddrProv }} {{ address.AddrPostalCode }}</div>
                <div>{{ address.AddrCountry }}</div>
                <div v-show="address.AddrPhone != ''">Phone: {{ address.AddrPhone }}</div>
                <div class="address-nav">
                  <van-button class="edit-button" @click="toEditMemberAddress(address)">Edit</van-button>
                  <van-button class="del-button" @click="toDeleteMemberAddress(address)">Delete</van-button>
                </div>
              </div>
            </van-grid-item>
          </van-grid>

          <van-button plain round type="default" class="btn_history" @click="toOrderHistory">{{ $t("member.orderHistory") }}</van-button>
          <van-button plain round type="default" class="btn_logout" @click="toLogout">{{ $t("login.signOut") }}</van-button>
        </div>
      </div>

      <div v-if="modifying && editingProfile">
        <div class="padding_20">
          <van-field label="Name" v-model="member.Name" placeholder="Member Name" v-show="member.OpenId" readonly class="uneditable" />
          <van-field label="Name" v-model="member.Name" placeholder="Member Name" v-show="!member.OpenId" />
          <van-field label="Email" v-model="member.eMailAddress" placeholder="email address" readonly class="uneditable" />
          <van-field label="Phone" v-model="member.Phone" placeholder="Phone Number 123-456-7890" />

          <van-button type="default" class="btn_save" plain round @click="toEditSave">{{ $t("member.save") }}</van-button>
          <van-button type="default" class="btn_cancel" plain round @click="toEditCancel">{{ $t("member.cancel") }}</van-button>
        </div>
      </div>

      <div v-if="modifying && editingAddress">
        <v-form class="addressForm" ref="form">
          <v-container>
            <v-row>
              <v-col cols="4" sm="3" align-self="center">
                <div class="float-right">Attention</div>
              </v-col>
              <v-col>
                <v-text-field placeholder="name of person or company" v-model="editAddress.AddrAttn" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3" align-self="center">
                <div class="float-right">Address</div>
              </v-col>
              <v-col>
                <v-text-field placeholder="address line 1" v-model="editAddress.AddrLine1" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3" align-self="center">
                <div class="float-right"></div>
              </v-col>
              <v-col>
                <v-text-field placeholder="address line 2" v-model="editAddress.AddrLine2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3" align-self="center">
                <div class="float-right">City</div>
              </v-col>
              <v-col>
                <v-text-field placeholder="city or town" v-model="editAddress.AddrCity" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3" align-self="center">
                <div class="float-right">Province</div>
              </v-col>
              <v-col>
                <v-select placeholder="province or territory" v-model="editAddress.AddrProv" :items="provinces" :rules="[rules.required]"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3" align-self="center">
                <div class="float-right">Postal code</div>
              </v-col>
              <v-col>
                <v-text-field placeholder="H0H-0H0" v-model="editAddress.AddrPostalCode" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3" align-self="center">
                <div class="float-right">Phone</div>
              </v-col>
              <v-col>
                <v-text-field placeholder="(416) 123-4567" v-model="editAddress.AddrPhone" :rules="[rules.required, rules.phone]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-2">
                <v-btn block rounded class="btn_save" @click="toSaveMemberAddressEdit"> {{ $t("member.save") }}</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pa-2">
                <v-btn block rounded class="btn_cancel" @click="toCancelMemberAddressEdit"> {{ $t("member.cancel") }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <!-- <div class="address-editbox" style="overflow:hidden">
          <van-form @submit="toSaveMemberAddressEdit"> -->
        <!-- <van-field
              label="Name"
              v-model="editAddress.AddrName"
              placeholder="Address Name"
              :disabled="editAddressOldName != ''"
              required
              :rules="[{ required: true, message: 'Username is required' }]"
            /> -->
        <!-- <van-field label="Attention To" v-model="editAddress.AddrAttn" placeholder="Person / Company" required /> -->
        <!-- <van-field label="Description" v-model="editAddress.AddrDescription" placeholder="Address Description" /> -->
        <!-- <van-field label="Address 1" v-model="editAddress.AddrLine1" placeholder="Address Line 1" required /> -->
        <!-- <van-field label="Address 2" v-model="editAddress.AddrLine2" placeholder="Address Line 2" /> -->
        <!-- <van-field label="City" v-model="editAddress.AddrCity" placeholder="City" required /> -->

        <!-- <div class="prov-div">
              <div class="prov-label"><span class="field-required">*</span>Province</div>
              <v-select class="prov-selector" v-model="editAddress.AddrProv" :items="provinces" dense xoutlined></v-select>
            </div> -->

        <!-- <van-field label="Postal Code" v-model="editAddress.AddrPostalCode" placeholder="Postal Code" required /> -->
        <!-- <van-field label="Country" v-model="editAddress.AddrCountry" placeholder="Country" readonly class="uneditable" /> -->
        <!-- <van-field label="Phone" v-model="editAddress.AddrPhone" placeholder="Phone 123-456-7890" required /> -->
        <!-- <van-field label="Email" v-model="editAddress.AddrEMail" placeholder="Email" /> -->

        <!-- <van-button
              plain
              round
              type="default"
              class="btn_save"
              native-type="submit"
              :disabled="
                editAddress.AddrAttn == undefined ||
                  editAddress.AddrAttn == '' ||
                  editAddress.AddrLine1 == undefined ||
                  editAddress.AddrLine1 == '' ||
                  editAddress.AddrCity == undefined ||
                  editAddress.AddrCity == '' ||
                  editAddress.AddrProv == undefined ||
                  editAddress.AddrProv == '' ||
                  editAddress.AddrPostalCode == undefined ||
                  editAddress.AddrPostalCode == '' ||
                  editAddress.AddrPhone == undefined ||
                  editAddress.AddrPhone == ''
              "
              >{{ $t("member.save") }}</van-button
            > -->
        <!-- <van-button plain round type="default" class="btn_cancel" @click="toCancelMemberAddressEdit">{{ $t("member.cancel") }}</van-button> -->
        <!-- </van-form> -->
        <!-- </div> -->
      </div>

      <div>{{ errorMsg }}</div>
    </div>
  </v-container>
</template>

<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      admin: this.$store.state.member.AdminRole,

      loggedIn: false,
      authData: {},

      editingProfile: false,
      editingAddress: false,

      errorMsg: "",

      editAddressOldName: "",
      editAddress: {},

      provinces: [],
      showProvPicker: false,
      provPickerIndex: 0,
      defaultCountry: "CANADA",

      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          return this.$isValidEmail(value) || "Invalid e-mail.";
        },
        phone: (value) => {
          return this.$isValidPhoneNumber(value) || "Invalud phone number";
        },
      },
    };
  },
  // ------------------------------------------------------------------------
  computed: {
    authenticated() {
      return this.loggedIn;
    },
    modifying() {
      return this.editingProfile || this.editingAddress;
    },
    firstName() {
      if (this.member.Name) {
        return this.member.Name.split(" ")[0];
      }
      return null;
    },
    member() {
      return this.$store.state.member;
    },
    addresses() {
      return this.$store.state.addresses;
    },
  },
  // ------------------------------------------------------------------------
  watch: {
    showProvPicker: (newValue, oldValue) => {
      if (newValue) {
        this.provPickerIndex = this.provinces.indexOf(this.editAddress.AddrProv);
      }
    },
  },
  // ------------------------------------------------------------------------
  created() {
    this.getCountryRegionList();
  },
  // ------------------------------------------------------------------------
  beforeDestroy() {
  },
  // ------------------------------------------------------------------------
  mounted() {
    this.editingProfile = false;
    this.editingAddress = false;
    this.$parent.curTab = 4;

    this.loggedIn = false;
    if (this.member.SessionToken) {
      this.loggedIn = true;
    }

    if (window.google && window.google.accounts) {
      window.google.accounts.id.initialize({
        client_id: '142656710507-2qpc1a3imshjmcba7n3g1qfgiujjmfk4.apps.googleusercontent.com',
        scopes: ['email', 'profile', 'openid'],
        callback: this.handleCredentialResponse,
        native_callback: this.handleCredentialResponse,
        // ux_mode: "redirect",
        // itp_support: true,
        // auto_select: true,
      });
      // window.google.accounts.id.prompt((notification) => {
      //   if (notification.isNotDisplayed() || !notification.isDisplayed()) {
      window.google.accounts.id.renderButton(
        this.$refs.googleLoginBtn, {
        text: 'signin_with',
        size: 'large',
        shape: 'circle',
        // theme: 'filled_blue',
        // theme: 'outline',
        // width: 400,
        // click_listener: this.Test
      });
      //   }
      // });
    }


    // retrieve member info if any
    this.getMemberInfo();
  },

  methods: {
    async handleCredentialResponse(response) {
      this.authData = response;
      this.checkAuthToken();
      // Put your backend code in here
    },
    // ------------------------------------------------------------------------ toLoginGoogle    
    // toLoginGoogle() {
    //   google.accounts.id.prompt();
    // },
    // ------------------------------------------------------------------------ toLoginEmail
    toLoginEmail() {
      this.$router.push({ name: "login" });
    },
    // ------------------------------------------------------------------------ toRegister
    toRegister() {
      this.$router.push({ name: "register" });
    },
    // ------------------------------------------------------------------------ toLogout
    toLogout() {
      this.authData = {};
      this.loggedIn = false;
      this.$store.commit("member", {});

      this.$ajax2.post("LogoutMember", { AppVersion: this.$version }, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.$toast({
              message: "logged out",
              position: "bottom",
            });
            location.reload();

            //this.$router.push({ name: "login" });
          }
        }).catch((err) => { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ toOrderHistory
    toOrderHistory() {
      this.$router.push({ name: "orderHistory" });
    },
    // ------------------------------------------------------------------------ toAdmin
    toAdmin() {
      this.$router.push({ name: "admin" });
    },
    // ------------------------------------------------------------------------ getCountryRegionList
    getCountryRegionList() {
      this.$ajax2.post("GetCountryRegionList", { AppVersion: this.$version }, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.provinces = [];
            let countryCanada = rpdata.data.data.find((ele) => ele.Country === this.defaultCountry);
            this.provinces = countryCanada.Region;
          }
        }).catch((err) => { console.log(err); }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ provPickerChanged
    provPickerChanged(picker, value, index) {
      this.showProvPicker = false;
      this.editAddress.AddrProv = value;
    },
    // ------------------------------------------------------------------------ provPickerConfirmed
    provPickerConfirmed(value, index) {
      this.showProvPicker = false;
      this.editAddress.AddrProv = value;
    },
    // ------------------------------------------------------------------------ provPickerConfirmed
    checkAuthToken() {
      if (this.authData && Object.keys(this.authData).length !== 0) {
        let credential = this.authData.credential;
        let obj = { AppVersion: this.$version, gsiCredential: credential };
        this.$ajax2.post("GetMember", obj, this.$ajaxHeader)
          .then((rpdata) => {
            if (rpdata.data.meta.code == "200") {
              this.$store.commit("member", rpdata.data.data);
              this.loggedIn = true;
            } else {
              this.$store.commit("member", {});
              this.errorMsg = rpdata.data.meta.msg;
              this.$toast({
                message: this.$t("text.dataError"),
                position: "bottom",
              });
            }
          }).catch((err) => { console.log(err); }); // eslint-disable-line
      }
    },
    // ------------------------------------------------------------------------ getMemberInfo
    getMemberInfo() {
      if (this.loggedIn && this.member.SessionToken) {
        let obj = {
          AppVersion: this.$version,
          SessionId: this.member.SessionId,
          SessionToken: this.member.SessionToken,
        };
        this.$ajax2.post("GetMember", obj, this.$ajaxHeader)
          .then((rpdata) => {
            if (rpdata.data.meta.code == "200") {
              this.$store.commit("member", rpdata.data.data);
            } else {
              this.$store.commit("member", {});
              this.errorMsg = rpdata.data.meta.msg;
              this.$toast({
                message: this.$t("text.dataError"),
                position: "bottom",
              });
            }
          }).catch((err) => { }); // eslint-disable-line
      }
    },
    // ------------------------------------------------------------------------ toEdit
    toEdit() {
      this.editingProfile = true;
    },
    // ------------------------------------------------------------------------ toEditSave
    toEditSave() {
      if (this.$isValidPhoneNumber(this.member.Phone)) {
        let obj = {
          AppVersion: this.$version,
          SessionId: this.member.SessionId,
          SessionToken: this.member.SessionToken,
          data: this.member,
        };
        this.$ajax2.post("PutMember", obj, this.$ajaxHeader)
          .then((rpdata) => {
            if (rpdata.data.meta.code == "200") {
              this.editingProfile = false;
              this.getMemberInfo();
            } else {
              this.errorMsg = rpdata.data.meta.msg;
              this.$toast({
                message: this.$t("text.dataError"),
                position: "bottom",
              });
            }
          }).catch((err) => { }); // eslint-disable-line
      } else {
        this.$toast({
          message: "Invalid phone number",
          position: "bottom",
        });
      }
    },
    // ------------------------------------------------------------------------ toEditCancel
    toEditCancel() {
      this.editingProfile = false;
      this.getMemberInfo();
    },
    // ------------------------------------------------------------------------ toAddMemberAddress
    toAddMemberAddress(editingBillingAddress) {
      this.editAddress = {};
      this.editAddress.AddrCountry = this.defaultCountry;
      this.editAddressOldName = "";
      this.editingAddress = true;
    },
    // ------------------------------------------------------------------------ toEditMemberAddress
    toEditMemberAddress(address) {
      this.editAddress = Object.assign({}, address);
      this.editAddressOldName = address.AddrName;
      this.editingAddress = true;
    },
    // ------------------------------------------------------------------------ toDeleteMemberAddress
    toDeleteMemberAddress(address) {
      Dialog.confirm({
        title: "Delete address " + address.AddrName,
        confirmButtonText: "Confirm?",
        cancelButtonText: "Cancel",
      }).then(() => {
        this.deleteAddress(address.AddrName);
      }).catch(() => { });  // eslint-disable-line
    },
    // ------------------------------------------------------------------------ toCancelMemberAddressEdit
    toCancelMemberAddressEdit() {
      this.editAddress = {};
      this.editAddressOldName = "";
      this.editingAddress = false;
    },
    // ------------------------------------------------------------------------ toSaveMemberAddressEdit
    toSaveMemberAddressEdit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      if (this.editAddressOldName != "") {
        obj.AddrName = this.editAddressOldName;
        obj.data = this.editAddress;
      } else {
        obj.AddrName = Date.now();
        obj.data = this.editAddress;
        if (!obj.data.AddrName) {
          obj.data.AddrName = obj.AddrName;
        }
      }
      this.$ajax2.post("PutMemberAddress", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            //this.newAddress = {};
            this.editAddress = {};
            this.editAddressOldName = "";
            this.editingAddress = false;

            this.getAddresses();
          } else {
            this.errorMsg = rpdata.data.meta.msg;
            this.$toast({
              message: this.$t("text.dataError"),
              position: "bottom",
            });
          }
        }).catch((err) => { console.log(err); }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ deleteAddress
    deleteAddress(addressName) {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        AddrName: addressName,
      };
      this.$ajax2.post("DeleteMemberAddress", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.getAddresses();
          } else {
            alert("address deletion not successful");
          }
        })
        .catch((err) => { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getAddress
    getAddress(addressName) {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        AddrName: addressName,
      };
      this.$ajax2.post("GetMemberAddress", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.editAddress = rpdata.data.data;
            this.editAddressOldName = rpdata.data.data.AddrName;
          } else {
            alert("unsuccessful");
          }
        })
        .catch((err) => { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getAddresses
    getAddresses() {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      this.$ajax2.post("GetMemberAddresses", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.$store.commit("addresses", rpdata.data.data);
          }
        })
        .catch((err) => { }); // eslint-disable-line
    },
  },
};
</script>

<style>
#member .addressForm div.col {
  padding-top: 0px;
  padding-bottom: 0px;
}

.address-item {
  flex-basis: 100% !important;
  padding-right: 10px;
}

@media screen and (min-width: 600px) {
  .address-item {
    flex-basis: 50% !important;
  }
}

@media screen and (min-width: 960px) {
  .address-item {
    flex-basis: 33.33% !important;
  }
}

/* @media screen and (min-width: 1280px) {
  .address-item {
    flex-basis: 25% !important;
  }
} */

.logo_banner {
  width: 80%;
  display: block;
  margin: 0 auto;
  padding-top: 20px;
}

.address-header {
  font-weight: bold;
  font-size: 1.2em;
  margin-left: 15px;
}

.address-add-button {
  margin-right: 15px;
  background-color: rgb(158, 238, 169);
  width: 120px;
}

.address-nav {
  /* margin-top: 2vh; */
  padding-top: 4vh;
  bottom: 30px;
  position: absolute;
}

/*
.address-nav .edit-button {
}
*/
.address-nav .del-button {
  margin-left: 10px;
  background-color: rgb(161, 28, 28);
  color: white;
}

.address-editbox {
  padding: 10px;
}

.prov-div {
  display: flex;
  padding: 0px 0px;
  margin-left: 16px;
  border-bottom: 1px solid #ebedf0;
}

.prov-label {
  width: 90px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  margin-top: auto;
  margin-bottom: auto;
}

.prov-selector {
  font-family: Roboto, sans-serif;
  font-size: 12px;
}

.field-required {
  margin-left: -8px;
  padding-right: 4px;
  color: red;
}

#member .address {
  text-align: left;
  width: 97%;
  height: 100%;
  border-radius: 8px;
  border: 1px solid rgb(197, 218, 224);
  /* margin-bottom: -10px; */
  /* margin-top: -10px; */
  padding: 10px;
  padding-bottom: 100px;
}

#member .uneditable input {
  color: gray;
}

#member .uneditable {
  color: gray;
}

#member .van-hairline--top-bottom::after {
  border-width: 0;
}

#member .header1 {
  position: fixed;
  width: 100%;
  top: 0;
}

#member .barImg {
  vertical-align: top;
  margin-right: 10px;
}

#member .bar_interval {
  height: 6px;
  background-color: black;
  width: 100%;
}

#member v-btn {
  text-transform: none !important;
}

#member .btn_login {
  color: indigo;
  text-transform: none !important;
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
}

#member .btn_history {
  margin-top: 4vh;
  width: 100%;
  display: block;

  background-color: #5f8dff;
  color: #ffffff;
  /* display: block; 1
  background-color: #dbcd8c; */

  /* border: 0; */
}

#member .btn_logout {
  margin-top: 4vh;
  width: 100%;
  display: block;
  /* background-color: #8cdbcc; */
  background-color: rgb(255, 175, 175);
  /* display: block; 1
  background-color: #dbcd8c; */
  /* color: #ffffff; */
  /* border: 0; */
}

#member .btn_edit {
  margin-top: 1vh;
  width: 100%;
  display: block;
  background-color: #8cdbcc;
  /* color: #ffffff; */
  /* border: 0; */
}

#member .btn_admin {
  margin-top: 1vh;
  width: 100%;
  display: block;
  color: black;
  /* color: #ffffff; */
  /* border: 0; */
}

#member .btn_save {
  margin-top: 5vh;
  width: 100%;
  display: block;
  background-color: rgb(158, 238, 169);
  color: black;
  /* display: block;
  background-color: #90e67b;2
  color: #ffffff; */
}

#member .btn_cancel {
  margin-top: 1vh;
  width: 100%;
  display: block;
  background-color: rgb(255, 175, 175);
  color: black;
  /* display: block;
  background-color: #f58d8d;3
  color: #ffffff; */
}

#member .btn {
  margin-top: 1%;
  background-color: rgb(171, 211, 218);
  width: 100%;
  height: 50px;
  color: #ffffff;
  border: 0;
}

#member .logout_btn {
  background-color: rgb(206, 94, 94);
  width: 100%;
  height: 50px;
  color: #ffffff;
}

#member .gsibtn>div {
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
}

#member .remark {
  background-color: black;
  color: black;
  padding: 5px 12px;
  line-height: 15px;
}

#member {
  width: 100%;
  margin-bottom: 20px;
  /* height: -webkit-fill-available; */
}
</style>
